import jQuery from 'jquery';
import 'slick-carousel';
/* eslint-disable no-console */
const ContinuousSlider = {
  onReady: () => {
    // eslint-disable-next-line no-unused-vars
    (function ($) {
      const sliderOptions = {
        speed: 10000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        dots: false,
        arrows: false,
        infinite: true,
      };

      const slider1 = $('.continuous-slider__row-1').slick(sliderOptions);
      const slider2 = $('.continuous-slider__row-2').slick({ ...sliderOptions, slidesToScroll: 2 });

      slider1.slick('slickGoTo', 2); // Change the starting position for slider1
      slider2.slick('slickGoTo', 3); // Change the starting position for slider2
    })(jQuery);
  },
};

export default ContinuousSlider;
